import {ContractFile} from "../integration/representation/file";

export default class FileList {
    private localFiles: LocalFile[] = [];

    constructor(public files:ContractFile[] = []) {
    }

    addLocalFile(localFile: File): LocalFile {
        const file = {
            localFile,
            name: localFile.name,
            status: 'LOCAL',
            size: localFile.size,
            numberInUploadQueue: 0
        };
        this.localFiles.unshift(file);
        return file;
    }

    replace(localFile: LocalFile, fileFromServer: ContractFile) {
        const idx = this.localFiles.indexOf(localFile);
        if (idx !== -1) {
            this.localFiles.splice(idx, 1);
            fileFromServer.numberInUploadQueue = localFile.numberInUploadQueue;
            this.files.unshift(fileFromServer);
        }
    }

    replaceContractFile(id: string, newFile: ContractFile) {
        this.files = this.files.map(file => file.id === id ? newFile : file);
    }

    getFile(id: string): ContractFile | undefined {
        let file;
        this.files.forEach(function(f) {
            if (f.id == id) {
                file = f;
            }
        });
        return file;
    }

    getFiles(idList: string[]): ContractFile[] {
        const files: ContractFile[] = [];
        this.files.forEach(function(f) {
            if (idList.indexOf(f.id) !== -1) {
                files.push(f);
            }
        });
        return files;
    }

    removeFile(id: string) {
        this.files.forEach(function(f: ContractFile, idx: number) {
            if (f.id == id) {
                this.files.splice(idx, 1);
            }
        }.bind(this));
    }
}

export interface LocalFile {
    localFile: File;
    name: string;
    status: string;
    size: number;
    numberInUploadQueue: number;
}